import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiGoalResponseModel } from '@/types'

export const getKpiGoals = async (
  startDate: string,
  endDate: string,
  kpiGroupName: string,
  branch?: string
): Promise<KpiGoalResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/get-kpi-goals`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        kpi_group_name: kpiGroupName,
        ...(branch && { branch }),
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
